import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>403</h1>

      <h2>Nuk jeni i autorizuar</h2>

      <p>Ju nuk keni të drejtë aksesi në këtë faqe.</p>

      <button onClick={() => navigate("/manage/dashboard")}>
        Kthehu te Dashboard
      </button>
    </div>
  );
};

export default Unauthorized;
